import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";
import { ValidacaoEncerramentoForm } from "features/projetos/pages/ProjetoEditPage/tabs/ValidacoesTab";

async function createValidacaoEncerramento(data: ValidacaoEncerramentoForm): Promise<IResponse<ValidationResult>> {
    return await axios.put(`/Validacao/Encerramento/${data.projetoId}`, data);
}

export default createValidacaoEncerramento;